import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'
import UUID from 'vue-uuid'
import '../public/theme/index.css'

import axios from 'axios'
import App from './App.vue'
import store from './store'
import router from './router'
import './bootstrapElementUI'
import { Message } from 'element-ui'
import ElInputTag from 'el-input-tag'
import underscore from 'vue-underscore';
import EventBus from "vue-super-eventbus"
import i18n from './i18n'
import './iconComponents'
import dotenv from 'dotenv'
import Clipboard from 'v-clipboard'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import * as am5 from '@amcharts/amcharts5';
am5.addLicense("AM5C343814994");


dotenv.config();

// register globally
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response.status === 401) {
    window.localStorage.removeItem('user');
    if (window.location.pathname != '/login' && !window.location.pathname.startsWith('/verify-mfa')) {
      location.replace(`/login?returnUrl=${window.location.pathname}`)
    }
    throw error
  }
  else if (error.response.status === 400) {
    (error.response.data.errors.forEach(x => setTimeout(() => Message.error(`${x.msg}`), 1)))
    throw error
  }
  else if (error.response.status === 403) {
    // sayfa içinde erişilen çeşitli kaynaklar olabilir her biri için mesaj atmamalıyız.
    // Message.warning("admin.accessDenied")
    throw error
  }
  else if (error.response.status === 409 || error.response.status === 404) {
    Message.error(error.response.data.message)
    throw error
  }
  else if (error.response.status.toString().startsWith('4')) {
    Message.error(error.response.data.message)
    throw error
  } else {
    throw error
  }
})
axios.defaults.headers.common['language'] = i18n.locale

Vue.use(Clipboard)
Vue.use(VueObserveVisibility)
Vue.use(underscore)
Vue.use(ElInputTag)
Vue.config.productionTip = false
Vue.use(UUID)
EventBus.install(Vue)
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_CHAPTCHA_SITEKEY });


Vue.mixin({
  methods: {
    checkPermission: function (permissionName) {
      return (store.state.account.user && (store.state.account.user.role == "admin" || store.state.account.user.permissions.includes(permissionName))) || true
    }
  }
})
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: h => h(App),
 

})


